<ng-container *transloco="let t">

  <div class="modal-header d-flex justify-content-start align-items-center cursor-pointer" (click)="activeModal.dismiss('Cross click')">
    <img src="assets/icons/icons-alt/chevron-left.svg" alt="Back" class="card-body__icon py-1 me-2"/>
    <p class="fs-20 fw-medium"> {{ t('my.entry.qr.codes.title') }} </p>
  </div>


  <div class="modal-body" style="background-color: var(--grey-neutral-50); padding-bottom: 65px;">
    <div class="section position-relative d-flex flex-column">
      <div class="flex-grow-1 overflow-hidden p-16">
          <p class="fw-semibold fs-18">
            <app-language-output
              [hrLabel]="event?.name"
              [enLabel]="event?.nameEng"
              [itLabel]="event?.nameIta"
              [siLabel]="event?.nameSlo"
              [srLabel]="event?.nameSr"
              [bsLabel]="event?.nameBs"
              [defaultLanguage]="event?.defaultLanguage"
              [languages]="languages">
            </app-language-output>
          </p>
          <p class="fs-16 color-slate-600">
            <app-language-output
              [hrLabel]="race?.name"
              [enLabel]="race?.nameEng"
              [itLabel]="race?.nameIta"
              [siLabel]="race?.nameSlo"
              [srLabel]="race?.nameSr"
              [bsLabel]="race?.nameBs"
              [defaultLanguage]="event?.defaultLanguage"
              [languages]="languages">
            </app-language-output>
          </p>
      </div>

      <div class="divider-horizontal"></div>

      <div class="p-16">
        <div class="d-flex align-items-center pe-3 color-slate-600">
          <app-event-date-display [start]="race?.raceStart" [end]="race?.raceEnd" [showIcon]="true"/>
        </div>
        <div class="d-flex align-items-center pe-3 color-slate-600">
          <i class="bi bi-clock card-body__icon fs-18 pe-2" style="justify-self: center; -webkit-text-stroke: 0.7px var(--teal-500);"></i>
          {{ race ? (race.raceStart | localizedDate:'shortTime') : '-' }}
        </div>
      </div>
    </div>


      <ng-template [ngTemplateOutlet]="qrCode" [ngTemplateOutletContext]="{
      title: 'Event T-shirt',
      option: 'Size M - selected',
      id: '#RACE-7721-T'
      }"></ng-template>
      <ng-template [ngTemplateOutlet]="qrCode" [ngTemplateOutletContext]="{
      title: 'Post-race meal',
      option: 'Vegetarian option - selected',
      id: '#RACE-7721-T'
      }"></ng-template>

  </div>

  <!-- FOOTER -->
  @if(registrationConfirmed) {
    <div class="modal-footer d-flex justify-content-center align-items-center pb-4" style="background-color: white">
      <div class="mb-3">
        <p class="fs-14 color-slate-600">{{ t('my.entry.qr.codes.problem') }}</p>
      </div>

      <app-button-alt
        [text]="t('my.entry.qr.codes.help') | uppercase"
        [borderColor]="'var(--teal-500)'"
        [textColor]="'var(--teal-500)'"
        [buttonColor]="'transparent'"
        (onClickCallback)="activeModal.close()"
        [buttonHeight]="'44px'"
        [isFullWidth]="true">
      </app-button-alt>
    </div>
  }

  <ng-template #qrCode let-title="title" let-option="option" let-codeId="id">
    <div class="section position-relative d-flex flex-column mt-3">
      <div class="d-flex justify-content-between align-items-center p-16" style="background-color: var(--teal-50); border-top-left-radius: 8px; border-top-right-radius: 8px;">
        <div>
          <p>
            {{title}}
          </p>
          <p class="fs-14 color-slate-600">
            {{option}}
          </p>
        </div>
        <div class="info-tag px-8" [ngClass]="registrationConfirmed ? 'green' : ''">
        @if(!registrationConfirmed) {
          <img src="assets/icons/icons-alt/lock.svg" alt="Locked" class="card-body__icon" style="justify-self: center; height: 16px; width: 16px;"/>
          <p class="ps-2">{{ t('my.entry.qr.codes.status.2') }}</p>
        } @else {
          <p class="color-slate-600">{{ t('my.entry.qr.codes.status.1') }}</p>
        }
        </div>
      </div>

      <div class="qr-container">
        <div class="d-flex justify-content-center align-items-center p-16"
             [class.qr-disabled]="!registrationConfirmed">
          <img src="assets/icons/icons-alt/qr-code.svg" alt="Qrcode" style="height: 140px; width: 140px;"/>
        </div>

        <div class="locked-overlay" *ngIf="!registrationConfirmed">
          <div class="lock-icon">
            <img src="assets/icons/icons-alt/lock.svg" alt="Locked" style="height: 24px; width: 24px;"/>
          </div>
          <p class="lock-text">{{ t('my.entry.payment.required') }}</p>
        </div>
      </div>

      <div class="divider-horizontal"></div>

      <div class="d-flex justify-content-between align-items-center fs-14 color-slate-600 p-16">
        <p>{{ t('my.entry.qr.codes.entitlement.id') }}</p>
        <p>{{codeId}}</p>
      </div>
    </div>
  </ng-template>

</ng-container>
